import { List, ResourceSectionCard } from '@all-manager/design-system-v2';
import { useGetOpenPendingItems } from '../../api/useGetOpenPendingItems';
import OpenPendingItem from './OpenPendingItem';

export default function OpenPendingItemsSection() {
  const { data: pendingItems, isLoading } = useGetOpenPendingItems();

  const items = pendingItems ?? [];

  return (
    <ResourceSectionCard
      variant="pending_item"
      title="À suivre"
      count={items.length}
      isLoading={isLoading}
      isEmpty={items.length === 0}
      emptyLabel="Rien à suivre"
    >
      <List disablePadding>
        {items.map((item) => (
          <OpenPendingItem key={item.id} item={item} />
        ))}
      </List>
    </ResourceSectionCard>
  );
}
